import { DATA_GRID_CHECKBOX_STATES } from "../constants";

const getCheckboxValue = ({ value, negatedValue, isIndeterminate }) => {
  if (negatedValue) {
    return !value
      ? DATA_GRID_CHECKBOX_STATES.CHECKED
      : DATA_GRID_CHECKBOX_STATES.UNCHECKED;
  }

  return value
    ? DATA_GRID_CHECKBOX_STATES.CHECKED
    : isIndeterminate
    ? DATA_GRID_CHECKBOX_STATES.INDETERMINATE
    : DATA_GRID_CHECKBOX_STATES.UNCHECKED;
};

export default getCheckboxValue;
